<div class="notifications-panel" *ngIf="isOpen">
    <div class="panel-header">
        <span class="panel-title">NOTIFICATIONS</span>
        <button type="button" class="mark-all" (click)="markAllRead.emit()">Mark all as read</button>
    </div>

    <div class="panel-body">
        <div *ngIf="notifications.length === 0" class="empty-state">
            No notifications
        </div>

        <div *ngFor="let notification of notifications" class="notification-card">
            <div class="notification-icon" [ngClass]="getIconClass(notification.type)">
                <mat-icon fontSet="material-icons-outlined">{{ getIcon(notification.type) }}</mat-icon>
            </div>
            <div class="notification-content">
                <div class="notification-header">
                    <span class="notification-title">{{ notification.title }}</span>
                    <span class="notification-time">{{ formatTime(notification.timestamp) }}</span>
                </div>
                <p class="notification-message">{{ notification.message }}</p>
            </div>
            <div class="unread-dot" *ngIf="!notification.isRead"></div>
        </div>
    </div>
</div>
